import { render, staticRenderFns } from "./WidgetILR.vue?vue&type=template&id=515beaec&scoped=true&lang=pug"
import script from "./WidgetILR.vue?vue&type=script&lang=ts"
export * from "./WidgetILR.vue?vue&type=script&lang=ts"
import style0 from "./WidgetILR.vue?vue&type=style&index=0&id=515beaec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515beaec",
  null
  
)

export default component.exports